import { Feature } from 'contexts/accounts/types';
import { CAPABILITY_FEATURE_SLUGS, CapabilityFlags } from './types';

// Missing/absent Backend feature data defaults to full access (fail-open) unless the
// caller explicitly opts out via options.failOpen — e.g. an expired B2B account should
// not fail open. Backend is the real authorization boundary; this is the merge-safe
// default for the DEV-5904/DEV-5808 rollout window while the contract is still in draft.
export const normalizeCapabilities = (
  features?: Feature[] | null,
  options?: { failOpen?: boolean }
): CapabilityFlags => {
  const failOpen = options?.failOpen ?? true;
  const enabledBySlug = new Map(
    (features ?? []).map((feature) => [feature.feature_slug, feature.enabled])
  );

  return CAPABILITY_FEATURE_SLUGS.reduce((flags, slug) => {
    flags[slug] = enabledBySlug.has(slug) ? Boolean(enabledBySlug.get(slug)) : failOpen;
    return flags;
  }, {} as CapabilityFlags);
};
